import type React from "react";
import { Children } from "react";
import { Box } from "../Box/Box";
import type { ResponsiveSpace } from "../Box/useBoxStyles";
import type { ReactNodeNoStrings } from "../private/ReactNodeNoStrings";
import {
  type Align,
  type AlignY,
  alignToFlexAlign,
  alignYToFlexAlign,
} from "../utils/align";
import {
  negativeMarginLeft,
  negativeMarginTop,
} from "../utils/negativeMarginCss";
import type { ResponsiveProp } from "../utils/responsiveProp";

export interface InlineProps {
  align?: ResponsiveProp<Align>;
  alignY?: ResponsiveProp<AlignY>;
  space: ResponsiveSpace;
  children: ReactNodeNoStrings;
  wrap?: boolean;
  style?: React.CSSProperties;
}

export const Inline = ({
  space = "none",
  align,
  alignY,
  children,
  wrap = true,
  style,
}: InlineProps): React.ReactNode => {
  const [lmClassName, lmCss] = negativeMarginLeft(space);
  const [tmClassName, tmCss] = negativeMarginTop(space);

  return (
    <Box className={tmClassName}>
      {lmCss}
      {tmCss}
      <Box
        display="flex"
        justifyContent={alignToFlexAlign(align)}
        alignItems={alignYToFlexAlign(alignY)}
        flexWrap={wrap ? "wrap" : "nowrap"}
        className={lmClassName}
        style={style}
      >
        {Children.map(children, (child) =>
          child !== null && child !== undefined ? (
            <Box minWidth={0} paddingLeft={space} paddingTop={space}>
              {child}
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  );
};
